import styled from '@emotion/styled';

export const AddRemoveButton = styled('button', { label: 'AddRemoveButton' })`
    border: 0;
    background: transparent;
    cursor: pointer;
    float: right;
    margin-top: 3px;
`;
